import script from "./PatientMatchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientMatchModal.vue?vue&type=script&setup=true&lang=js"

import "./PatientMatchModal.vue?vue&type=style&index=0&id=fd5038b4&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd5038b4"]])

export default __exports__